import { LitElement, html } from '@polymer/lit-element/lit-element';
import { when } from 'lit-html/directives/when';
import { until } from 'lit-html/directives/until';
import '@zywave/zui-colors';

class SvgCache {
  constructor() {
    this.cache = new Map();
  }

  static get instance() {
    return this._instance || (this._instance = new this());
  }

}

class ZuiSvg extends LitElement {
  static get properties() {
    return {
      svgId: {
        type: String,
        attribute: 'svg-id'
      },
      file: {
        type: String
      }
    };
  }

  constructor() {
    super();
    this.svgId = '';
    this.file = '';
  }

  _renderStyle() {
    return html`
      <style>
        :host{pointer-events:none;display:inline-block;width:var(--zui-svg-width, 24px);height:var(--zui-svg-height, 24px);line-height:1;fill:currentColor}:host .svg{pointer-events:inherit;display:inherit;width:inherit;height:inherit;line-height:inherit;fill:inherit;all:inherit}:host(.small){--zui-svg-width: 16px;--zui-svg-height: 16px}:host(.medium){--zui-svg-width: 36px;--zui-svg-height: 36px}:host(.large){--zui-svg-width: 48px;--zui-svg-height: 48px}.svg-defs{display:none}
      </style>
    `;
  }

  render() {
    let svgNodeClone = undefined;

    if (!this.svgId) {
      return html`
        <style>
          :host {
            display: none;
          }
        </style>
      `;
    }

    const svgNode = !this.file ? document.getElementById(this.svgId) : undefined;

    if (svgNode) {
      svgNodeClone = svgNode.cloneNode(true);
    }

    const isIE11 = /\bTrident\/[567]\b|\bMSIE (?:9|10)\.0\b/.test(navigator.userAgent);

    if (isIE11 && this.file) {
      return html`
        ${until(this._loadSvg(), html`
              <span class="svg-loading"></span>
            `)}
      `;
    }

    return html`
      ${this._renderStyle()}
      ${when(svgNodeClone, () => html`
              <svg class="svg-defs"><defs>${svgNodeClone}</defs></svg>
            `, () => html``)} <svg class="svg"><use href="${this.file}#${this.svgId}" xlink:href="${this.file}#${this.svgId}"></use></svg>
    `;
  }

  _loadSvg() {
    let p = undefined;

    if (SvgCache.instance.cache.has(this.file)) {
      p = SvgCache.instance.cache.get(this.file);
    } else {
      p = new Promise((resolve, reject) => {
        const request = new XMLHttpRequest();
        request.open('GET', this.file);

        request.onload = () => {
          if (request.status >= 200 && request.status < 300) {
            const newDoc = document.implementation.createHTMLDocument('');
            newDoc.body.innerHTML = request.responseText;
            resolve(newDoc);
          } else {
            reject({
              status: request.status,
              statusText: request.statusText
            });
          }
        };

        request.onerror = () => {
          reject({
            status: request.status,
            statusText: request.statusText
          });
        };

        request.send();
      });
      SvgCache.instance.cache.set(this.file, p);
    }

    return p.then(doc => this._buildSvg(doc));
  }

  _buildSvg(doc) {
    const s = doc.getElementById(`${this.svgId}`).cloneNode(true);
    return html`
      <svg class="svg-defs"><defs>${s}</defs></svg>
      <svg class="svg"><use href="#${this.svgId}" xlink:href="#${this.svgId}"></use></svg>
    `;
  }

}

customElements.define('zui-svg', ZuiSvg);